export default __webpack_public_path__ + "static/media/logo-text.b455caa3.png";